import * as React from 'react';
import {styled, emotionStyled, tokens} from '@packages/utilities/styled';

import {TypeImplementation} from '@packages/systems/wfdl';
import {TJson} from '@packages/systems/plugins/Json';
import {a, error, tyfun} from '@packages/utilities/wfdl-helpers';
import {StyledHelpIcon, TEffect} from '@packages/systems/plugins/Effect';
import TooltipControl from '@packages/systems/design-system/TooltipControl';

import Grid from '@packages/systems/design-system/Grid';
import {FinePrint} from '@packages/systems/design-system/Text';

import {
  LogicLabel,
  LogicCopyToClipboard,
  LogicEmptyState,
} from '@packages/systems/flows/shared';
import {selectWebhook} from '@packages/systems/flows/shared/selectors';
import {Webhooks20} from '@packages/systems/ui/icons';
import {VisuallyHidden} from '@packages/systems/spring';
import {useDesignerSelector} from '@packages/systems/designer/flux';

const TOOLTIP_CONTENT =
  'A unique URL that you can use to set up webhooks in a 3rd party service.';

const CopyTooltip = emotionStyled('div')({
  marginBottom: tokens.space[1],
});

export const WebhookParserType = TypeImplementation.Alias({
  params: ['error', 'a'],
  type: tyfun([TJson], TEffect(error, a)),
  system: {bindUIVariant: 'custom'},
  render: function RenderWebhookParser() {
    const trigger = useDesignerSelector(selectWebhook);
    const url = trigger?.meta?.url;

    return (
      <Grid gridRowGap={2}>
        <Grid gridRowGap={1}>
          <div>
            <StyledLabel label="Webhook URL ">
              <VisuallyHidden>{TOOLTIP_CONTENT}</VisuallyHidden>
              {/* @ts-expect-error - TS2739 - Type '{ "aria-hidden": true; icon: Element; content: string; alternate: true; }' is missing the following properties from type '{ [x: string]: any; iconStyle?: { padding: number; boxSizing: string; } | undefined; icon?: Element | undefined; cursor?: string | undefined; placement?: string | undefined; children: any; hideOnClick: any; style: any; automationLabel?: string | undefined; }': children, hideOnClick, style */}
              <TooltipControl
                aria-hidden
                icon={<StyledHelpIcon style={{paddingLeft: 2}} />}
                content={TOOLTIP_CONTENT}
                alternate
              />
            </StyledLabel>

            <FinePrint dim>Unique address to send your requests.</FinePrint>

            <LogicCopyToClipboard
              data-automation-id="logic-webhook-url-copy"
              hoverContent={
                url ? (
                  <span style={{overflowWrap: 'break-word'}}>
                    <CopyTooltip>Click to copy</CopyTooltip>
                    <strong>{url}</strong>
                  </span>
                ) : (
                  ''
                )
              }
              successContent="Copied URL successfully!"
              textToCopy={url || '...'}
            />
          </div>
        </Grid>

        <LogicEmptyState
          headingIcon={<Webhooks20 style={{width: 30, height: 30}} />}
          heading="Webhook Setup guide"
          content={[
            'Copy the webhook URL and paste it in the third-party app',
            'Submit sample data on your site',
            'Come back and run a test to complete setup',
          ]}
          // callToAction={{
          //   type: 'link',
          //   label: 'Learn more',
          //   href: 'webflow.com', // should open to university content link
          //   target: '_blank',
          //   rel: 'noopener noreferrer',
          // }}
        />
      </Grid>
    );
  },
});

const StyledLabel = styled(LogicLabel)(({theme: {gutters}}) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: `max-content ${gutters.x16}px`,
  gridColumnGap: gutters.x4,
}));
